import axios from 'axios';

const API_URL = 'http://localhost:9000';

const ImageCacheAPIService = {
    async cacheProducts(products) {
        try {
            let successCount = 0;
            let errorCount = 0;

            for (const product of products) {
                if (product.image_base64 && product.id) {
                    try {
                        await axios.post(
                            `${API_URL}/images/cache/${product.id}`,
                            {
                                imageData: product.image_base64,
                                mimeType: 'image/jpeg'
                            },
                            { timeout: 5000 }
                        );
                        successCount++;
                    } catch (error) {
                        console.error(`Error cacheando imagen ${product.id}:`, error.message);
                        errorCount++;
                    }
                }
            }

            console.log(`Cache API: ${successCount} imagenes guardadas, ${errorCount} errores`);
            return { success: successCount, errors: errorCount };

        } catch (error) {
            console.error('Error en cache masivo:', error);
            return { success: 0, errors: products.length };
        }
    },

    async getCacheStats() {
        try {
            const response = await axios.get(`${API_URL}/images/cache/stats`, { timeout: 3000 });
            return response.data;
        } catch (error) {
            console.error('Error obteniendo stats:', error);
            return null;
        }
    },

    async clearCache() {
        try {
            await axios.delete(`${API_URL}/images/cache`, { timeout: 3000 });
            console.log('Cache limpiado en API intermedia');
            return true;
        } catch (error) {
            console.error('Error limpiando cache:', error);
            return false;
        }
    }
};

export default ImageCacheAPIService;